import { render } from "./VerticalStepBar.vue?vue&type=template&id=5772c15b&ts=true"
import script from "./VerticalStepBar.vue?vue&type=script&lang=ts"
export * from "./VerticalStepBar.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__